import React from 'react';
import './StandardSearch.css';

export function matchesStandardSearch(query, values) {
  const terms = query.trim().toLowerCase().split(/\s+/).filter(Boolean);
  const text = values.filter(Boolean).join(' ').toLowerCase();
  return terms.every((term) => text.includes(term));
}

export default function StandardSearch({ value, onChange }: any) {
  return (
    <div className="ae-standard-search">
      <label>
        <span>Search standards</span>
        <input type="search" value={value} onChange={(event) => onChange(event.target.value)}
          placeholder="Search code, learning outcome, domain, or strand..." />
      </label>
      {value && <button type="button" onClick={() => onChange('')}>Clear search</button>}
    </div>
  );
}
